var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("div", {
    staticClass: "app-page-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(" " + _vm._s(_vm.id ? "编辑" : "新增") + " ")]), _c("div", {
    staticClass: "right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("返回")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")])], 1)]), _c("template-editor", {
    ref: "editor",
    attrs: {
      params: _vm.list,
      "tool-fixed": true,
      id: _vm.id,
      loading: _vm.loading,
      "default-editor-val": _vm.form.ctConfirm
    },
    on: {
      paramsChange: _vm.paramsChange
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };